// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IAddress } from './IAddress';
import {
    IAddressFromJSON,
    IAddressFromJSONTyped,
    IAddressToJSON,
    IAddressToJSONTyped,
} from './IAddress';

/**
 * 
 * @export
 * @interface IReissueDecision
 */
export interface IReissueDecision {
    /**
     * 
     * @type {string}
     * @memberof IReissueDecision
     */
    type: string;
    /**
     * 
     * @type {IAddress}
     * @memberof IReissueDecision
     */
    address?: IAddress;
    /**
     * 
     * @type {string}
     * @memberof IReissueDecision
     */
    benefit_of?: string;
    /**
     * 
     * @type {number}
     * @memberof IReissueDecision
     */
    payment_method_id?: number;
}

/**
 * Check if a given object implements the IReissueDecision interface.
 */
export function instanceOfIReissueDecision(value: object): value is IReissueDecision {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function IReissueDecisionFromJSON(json: any): IReissueDecision {
    return IReissueDecisionFromJSONTyped(json, false);
}

export function IReissueDecisionFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReissueDecision {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'address': json['address'] == null ? undefined : IAddressFromJSON(json['address']),
        'benefit_of': json['benefit_of'] == null ? undefined : json['benefit_of'],
        'payment_method_id': json['payment_method_id'] == null ? undefined : json['payment_method_id'],
    };
}

export function IReissueDecisionToJSON(json: any): IReissueDecision {
    return IReissueDecisionToJSONTyped(json, false);
}

export function IReissueDecisionToJSONTyped(value?: IReissueDecision | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'address': IAddressToJSON(value['address']),
        'benefit_of': value['benefit_of'],
        'payment_method_id': value['payment_method_id'],
    };
}

